import { Link } from 'react-router-dom';

const SOCIAL_LINKS = [
  { icon: 'ri-github-fill', href: 'https://github.com/guilherme-marostica-dev', label: 'GitHub', handle: '@developer' },
  { icon: 'ri-linkedin-fill', href: 'https://www.linkedin.com/in/guilhermesmarostica/', label: 'LinkedIn', handle: 'in/developer' },
  { icon: 'ri-code-s-slash-line', href: 'https://dev.to/gmarostica_dev', label: 'Dev.to', handle: '@developer' },
];

export default function HeroSection() {
  const handleContactScroll = () => {
    const el = document.getElementById('contact');
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section className="relative min-h-screen flex items-center overflow-hidden">
      {/* Background Image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=dark%20moody%20developer%20workspace%20dual%20monitors%20code%20editor%20dark%20theme%20neon%20glow%20keyboard%20bokeh%20cinematic%20professional%20atmospheric%20tech%20environment%20night%20setup&width=1440&height=900&seq=hero1&orientation=landscape"
          alt="Developer workspace"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-gray-950/90 via-gray-950/70 to-gray-950/40"></div>
      </div>

      {/* Content */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-6 md:px-10 pt-24 pb-16">
        <div className="max-w-2xl">
          {/* Eyebrow */}
          <div className="flex items-center gap-3 mb-6">
            <span className="inline-block w-8 h-px bg-emerald-400"></span>
            <span className="text-emerald-400 text-sm font-mono tracking-widest uppercase">
              WEB DEVELOPER & DATA ANALYTICS
            </span>
          </div>

          {/* Heading */}
          <h1 className="text-5xl md:text-7xl font-bold text-white leading-tight mb-6" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
            Building Digital Solutions
            <br />
            <span className="text-emerald-400">That Drive Results.</span>
          </h1>

          {/* Subtitle */}
          <p className="text-lg text-gray-300 leading-relaxed mb-10 max-w-xl">
            I'm a Brazilian developer based in Germany, helping small businesses build modern websites and improve their digital presence through technology and data.
          </p>

          {/* CTA Buttons */}
          <div className="flex flex-wrap gap-4 mb-12">
            <Link
              to="/projects"
              className="inline-flex items-center gap-2 px-7 py-3.5 bg-emerald-500 text-white font-semibold rounded-full hover:bg-emerald-400 transition-all duration-200 cursor-pointer whitespace-nowrap text-sm"
            >
              View My Work
              <i className="ri-arrow-right-line text-base"></i>
            </Link>
            <button
              onClick={handleContactScroll}
              className="inline-flex items-center gap-2 px-7 py-3.5 border border-white/30 text-white font-semibold rounded-full hover:bg-white/10 transition-all duration-200 cursor-pointer whitespace-nowrap text-sm"
            >
              Get In Touch
            </button>
          </div>

          {/* Social Links */}
          <div className="flex items-center gap-2">
            <span className="text-gray-500 text-xs font-mono mr-2">Find me on</span>
            {SOCIAL_LINKS.map((s) => (
              <a
                key={s.label}
                href={s.href}
                target="_blank"
                rel="nofollow noopener noreferrer"
                aria-label={s.label}
                className="w-9 h-9 flex items-center justify-center rounded-full border border-white/20 text-white/70 hover:text-white hover:border-emerald-400 hover:bg-emerald-400/10 transition-all cursor-pointer"
              >
                <i className={`${s.icon} text-base`}></i>
              </a>
            ))}
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-white/40 text-xs font-mono tracking-widest uppercase">Scroll</span>
        <i className="ri-arrow-down-line text-white/40 text-lg"></i>
      </div>
    </section>
  );
}